import { SpinnerLoader } from 'lift-ui';
import { useAuthContext } from '@lift-admin/utils/provider';

import { useNavigate } from 'react-router-dom';

const ProtectedRoute = ({ children }:{children:any}) => {
  const navigate = useNavigate()
  const { authUser, loading } = useAuthContext();

  if (loading) {
    return (
      <div
        className="fixed inset-0 z-[1201] flex items-center justify-center bg-white"
        aria-label="Loading"
      >
        <SpinnerLoader className="h-10 w-10" />
      </div>
    );
  }

  if (!authUser) {
    navigate("/")
  }

  return <>{children}</>;
};

export default ProtectedRoute;
